// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"a35e1278","133":"2ee8359c","182":"2ee1a5b3"}[chunkId] + ".chunk.js";
};